export default __webpack_public_path__ + "static/media/4.c02ba7b7.png";